import React from 'react';
import './account.scss';

import withFeatureFlags from '../../FeatureFlags/withFeatureFlags';
import {formatDate} from "../../../utils/helpers";
import checkIcon from "../../../assets/images/check-navy-circle.svg"

/** @import {RolloverAccountProps} from './RolloverAccountTypes' */
/** @import {WithFeatureFlagsProps} from '../../FeatureFlags/FeatureFlagsTypes' */
/** @import {Account} from "../DashboardTypes" */

function RolloverAccount(/** @type {WithFeatureFlagsProps & RolloverAccountProps} */ {account, product}) {
    
    const getRolloverRate = (/** @type {Account} */ account) => {
        let rolloverRate = 0;

        if (account && account.maturity && account.maturity.availableRolloverRates && account.maturity.rolloverAccountProductId) {
            const rolloverProduct = account.maturity.availableRolloverRates.find(r => account.maturity && r.productId === account.maturity.rolloverAccountProductId);
            if (rolloverProduct) {
                rolloverRate = rolloverProduct.rate;
            }
        }

        return rolloverRate;
    };

    const rolloverRate = getRolloverRate(account);
    const displayNtbRate = product ? product.rate > rolloverRate : false;
    const rate = product && displayNtbRate ? product.rate : rolloverRate;

    return <>
        <div className='rollover-account'>
            <div className={'rollover-account__content'}>
                <div className='rollover-account__title'>
                    Renewed {product ? product.name : ''} (opening soon)
                </div>
                <div className='rollover-account__detail'>
                    {displayNtbRate ?
                        <>
                            <p>
                            <img className={"maturity3__inline-icon"} alt={'check icon'} src={checkIcon}/>  As of today, you'll earn: <b>{rate}%</b> AER*
                        </p>
                            <p>
                                We'll always offer you our highest rate on the day your account matures. Currently, this is our
                                rate for new customers, which is higher than the renewal rate we originally offered you.
                            </p>
                        </> :
                        <>
                            <p>
                                <img className={"maturity3__inline-icon"} alt={'check icon'} src={checkIcon}/>  Renewal rate: <b>{rate.toFixed(2)}%</b> AER*
                            </p>
                            <p>
                                We'll always offer you our highest rate on the day your account matures. Currently, this is
                                your renewal rate, which is higher than or equal to our rate for new customers.
                            </p>
                        </>
                        
                    }
                </div>
            </div>
            <div className={'rollover-account__info'}>
                Opening on {account.maturity && account.maturity.maturityDate ? formatDate(account.maturity.maturityDate) : ''}
            </div>
        </div>
    </>
}
export default withFeatureFlags(RolloverAccount);
